

function Services() {
  return (
     


<div className="container">

    <section id="services" className="services">
        <div className="container">
  
          <div className="section-title" data-aos="fade-up"><br />
            <h2>Choose Your Telsim NBN Home Internet Plans</h2>
            <p>Telsim Broadband guarantees flawless connectivity for all your digital needs<br /> by providing blazing-fast internet speeds over Australia's reliable network. </p><br />
          </div>
  
          <div className="row">
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon"><i className="fa fa-bolt" aria-hidden="true"></i></div>
                <h3 className="title">Faster Internet Speeds</h3>
                <p className="description">When compared to conventional ADSL or cable connections, Telsim NBN<sup>&reg;</sup> offers faster and more dependable internet speeds. For tasks like streaming, playing games online, holding video conferences, and downloading big files, this is essential. </p>
              </div>
            </div>
  
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon"><i className="fa fa-hourglass-half" aria-hidden="true"></i></div>
                <h3 className="title">Unlimited Data with No Worries</h3>
                <p className="description">With our affordable unlimited plans, you won't ever have to worry about exceeding data allotment, paying extra for overuse, or having your speed slowed down. All the internet you require is provided. This is our acceptable use policy in effect.</p>
              </div>
            </div>
  
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div className="icon"><i className="fa fa-cogs" aria-hidden="true"></i></div>
                <h3 className="title">Broadband Speed Test</h3>
                <p className="description">To meet the diverse needs of its users, Telsim NBN<sup>&reg;</sup> provides multiple speed tiers. Whether they need high-speed connections for data-intensive activities or just basic internet access, users can select plans based on their usage patterns. </p>
              </div>
            </div>
  
          </div><br />

          <div className="row">
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon"><i className="fa fa-headphones" aria-hidden="true"></i></div>
                <h3 className="title">Skilled Support Technicians</h3>
                <p className="description">Our support technicians are all degree-qualified and happy to assist you if you require technical assistance. They will collaborate with you to resolve any problem you may have as soon as feasible. </p>
              </div>
            </div>
  
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon"><i className="fa fa-download" aria-hidden="true"></i></div>
                <h3 className="title">Self-Service with My Telsim</h3>
                <p className="description">You can control all your services more quickly and easily with My Telsim. You can examine your invoices, pay your account, adjust your plan, and keep an eye on your expenses and usage. </p>
              </div>
            </div>
  
            <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="400">
                <div className="icon"><i className="fa fa-handshake-o" aria-hidden="true"></i></div>
                <h3 className="title">Improved Reliability</h3>
                <p className="description">Telsim NBN<sup>&reg;</sup> is designed to be more reliable than older broadband technologies. It aims to reduce dropouts and provide a more consistent internet connection.</p>
              </div>
            </div>
  
          </div>
  
        </div><br />
      </section>
</div>





  );
}

export default Services;
